import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { tap } from 'rxjs/operators';
import { LoadingService } from 'app/core/services/loading.service';

@Injectable({
  providedIn: 'root'
})
export class UpcomingRemindersService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private loadingService: LoadingService,

  ) { }

  getUpcomingSchedulers() {
    const token = this.cookieService.get('accessToken');

    this.loadingService.enabled = false;
    return this.http.post('/api/scheduler/upcoming/get',`access_token=${token}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    }));
  }

  cancelReminder(taskId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify({taskId}))}`
    ];

    this.loadingService.enabled = false;
    return this.http.post('/api/scheduler/cancel', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(tap(()=> {
      this.loadingService.enabled = true;
    })); 
  }
}
